export const EXPORT_SOLR_ANALYSIS = [
  "acronym",
  "agent",
  "agent_id",
  "analysed_parameters",
  "analysis_method",
  "analysis_method_en",
  "counts",
  "database_id",
  "dataset_id",
  "dataset_ids",
  "date",
  "date_added",
  "date_changed",
  "date_end",
  "date_free",
  "depth",
  "depth_interval",
  "id",
  "id_sample_palaeontology",
  "instrument",
  "instrument_en",
  "instrument_id",
  "lab",
  "lab_analysis_number",
  "lab_en",
  "lab_id",
  "lab_sample_number",
  "latitude",
  "latlong",
  "lithostratigraphy",
  "lithostratigraphy_en",
  "lithostratigraphy_id",
  "locality",
  "locality_en",
  "locality_id",
  "location",
  "longitude",
  "mass",
  "mass_unit",
  "material",
  "method",
  "method_details",
  "method_details_en",
  "name",
  "name_en",
  "owner_id",
  "parent_analysis_id",
  "private",
  "reference_id",
  "remarks",
  "sample_id",
  "sample_id_temp",
  "sample_number",
  "sample_name",
  "site_id",
  "specimen_id",
  "storage_id",
  "stratigraphy",
  "stratigraphy_bed",
  "stratigraphy_en",
  "stratigraphy_id",
];

export const EXPORT_SOLR_ANALYTICAL_DATA = [
  "Ag_ppm",
  "Al2O3_pct",
  "Al_pct",
  "Allogenic_minerals__translucent__pct",
  "Amphibole_pct",
  "Anatase_pct",
  "Andalusite_pct",
  "Anhydrite_pct",
  "Apatite__biogenic__pct",
  "Apatite_pct",
  "As_ppm",
  "Au_ppm",
  "B_ppm",
  "BaO",
  "BaO_pct",
  "Ba_ppm",
  "Barite_pct",
  "Be_ppm",
  "Bi_ppm",
  "Biotite__brown__pct",
  "Biotite__green__pct",
  "Br_mgL",
  "Br_ppm",
  "Brucite_pct",
  "CO2_Amp",
  "CO2_pct",
  "Ca2__mgL",
  "CaO_pct",
  "Ca_pct",
  "Calcedon__opal_pct",
  "Calcedon_pct",
  "Calcite_pct__calculated",
  "Cassiterite_pct",
  "Cd_ppm",
  "Ce2O3_pct",
  "Ce_ppm",
  "Celestine_pct",
  "Chalcopyrite_pct",
  "Cl_mgL",
  "Cl_pct",
  "Clay_calculated_pct",
  "Co_ppm",
  "Cordierite_pct",
  "Corundum_pct",
  "Counts_grains",
  "Cr2O3_pct",
  "Cr_ppm",
  "Cs_ppm",
  "Cu_ppm",
  "Dolomite_pct__calculated",
  "Dry_density_kg_m3",
  "Dy_ppm",
  "Eh_mV",
  "Elektrijuhtivus_uS_cm",
  "Epidote_Zoisite_pct",
  "Epidote__zoisite_pct",
  "Er_ppm",
  "Eu_ppm",
  "F_pct",
  "Fe-hydroxide_pct",
  "Fe-hydroxides_pct",
  "Fe2O3",
  "Fe2O3T_pct",
  "Fe2O3_pct",
  "Fe2O3pct",
  "Fe2O3total_pct",
  "Fe2O5",
  "FeO_pct",
  "Fe_pct",
  "Feldspars_pct",
  "Ga_ppm",
  "Galenite_pct",
  "Garnet_pct",
  "Garnets_pct",
  "Gd_ppm",
  "Ge_ppm",
  "Glauconite_pct",
  "Grain_density_kg_m3",
  "Gypsum_pct",
  "Heavy_minerals_pct",
  "Hematite_pct",
  "Hf_ppm",
  "Ho_ppm",
  "Ilmenite__magnetite__pct",
  "Ilmenite_pct",
  "In_ppm",
  "Insoluble_residue_pct",
  "Insoluble_residue_pct__calculated",
  "K2O_pct",
  "K__mgL",
  "K_pct",
  "Kaolinite_pct",
  "Kyanite_pct",
  "LOI920_pct",
  "LOI_1030_pct",
  "LOI_450C_pct",
  "LOI_450_pct",
  "LOI_500C_pct",
  "LOI_550_pct",
  "LOI_920C_pct",
  "LOI_920_pct",
  "LOI_950C_pct",
  "LOI_pct",
  "La2O3_pct",
  "La_ppm",
  "Leucoxene_pct",
  "Li_ppm",
  "Limestone_pct",
  "Lu_ppm",
  "Maghemite_pct",
  "Magnetite_pct",
  "Mean_Amplitude",
  "Mean_Area",
  "Mg2__mgL",
  "MgO_pct",
  "Mg_pct",
  "Mica__weathered__pct",
  "Micas__weathered_pct",
  "Micas_pct",
  "Microcline_pct",
  "Mineraalsus_mgL",
  "MnO_pct",
  "MnO_ppm",
  "Mn_pct",
  "Mn_ppm",
  "Mo_ppm",
  "Monazite_pct",
  "Muscovite_pct",
  "Muskovite_pct",
  "N2_Amp",
  "N_pct",
  "Na2O__pct",
  "Na2O_pct",
  "Na2O_ppm",
  "Na__mgL",
  "Na_pct",
  "Nb_ppm",
  "Nd2O3_pct",
  "Nd_ppm",
  "Ni_ppm",
  "Oil_shale_pct",
  "Opaque_ore_minerals_pct",
  "Orthoclase_pct",
  "Orthoklase_pct",
  "P-wave_velocity_m_sec_in_dry_sample",
  "P-wave_velocity_m_sec_in_wet_sample",
  "P2O3_pct",
  "P2O5_pct",
  "P2O5_ppm",
  "PCAL_mg_P_kg",
  "P_ppm",
  "Pb_ppm",
  "Pd_ppm",
  "Plagioclase_pct",
  "Porosity_pct",
  "Pr_ppm",
  "Pt_ppm",
  "Purunemiskindlus__LA_",
  "Pyrite_pct",
  "Pyroxene_pct",
  "Pyrrhotite_pct",
  "Quartz_pct",
  "Rb_ppm",
  "Re_ppm",
  "Rutile_pct",
  "S-wave_velocity__m_sec_in_wet_sample",
  "SO3_pct",
  "SO4_2__mgL",
  "SUM_pct",
  "S_pct",
  "S_ppm",
  "Sb_ppm",
  "Sc_ppm",
  "Scheelite_pct",
  "Se_ppm",
  "SiO2__aq__mgL",
  "SiO2_pct",
  "Si_pct",
  "Siderite_pct",
  "Sillimanite_pct",
  "Size_fraction_0.005-0.001_mm_pct",
  "Size_fraction_0.01-0.002_mm_pct",
  "Size_fraction_0.01-0.005_mm_pct",
  "Size_fraction_0.05-0.01_mm_pct",
  "Size_fraction_0.056-0.01_mm_pct",
  "Size_fraction_0.06-0.01_mm_pct",
  "Size_fraction_0.06-0.01mm_pct",
  "Size_fraction_0.063-0.05_mm_pct",
  "Size_fraction_0.068-0.05_mm_pct",
  "Size_fraction_0.075-0.056_mm_pct",
  "Size_fraction_0.1-0.01_mm_pct",
  "Size_fraction_0.1-0.05_mm_pct",
  "Size_fraction_0.1-0.063_mm_pct",
  "Size_fraction_0.1-0.068_mm_pct",
  "Size_fraction_0.1-0.06_mm_pct",
  "Size_fraction_0.1-0.06mm_pct",
  "Size_fraction_0.1-0.07_mm_pct",
  "Size_fraction_0.105-0.063_mm_pct",
  "Size_fraction_0.105-0.075_mm_pct",
  "Size_fraction_0.15-0.105_mm_pct",
  "Size_fraction_0.16-0.105_mm_pct",
  "Size_fraction_0.16-0.1_mm_pct",
  "Size_fraction_0.2-0.15_mm_pct",
  "Size_fraction_0.2-0.16_mm_pct",
  "Size_fraction_0.25-0.16_mm_pct",
  "Size_fraction_0.25-0.1_mm_pct",
  "Size_fraction_0.25-0.2_mm_pct",
  "Size_fraction_0.28-0.16_mm_pct",
  "Size_fraction_0.315-0.25_mm_pct",
  "Size_fraction_0.315-0.28_mm_pct",
  "Size_fraction_0.315-0.2_mm_pct",
  "Size_fraction_0.4-0.315_mm_pct",
  "Size_fraction_0.42-0.315_mm_pct",
  "Size_fraction_0.5-0.25_mm_pct",
  "Size_fraction_0.5-0.315_mm_pct",
  "Size_fraction_0.5-0.42_mm_pct",
  "Size_fraction_0.5-0.4_mm_pct",
  "Size_fraction_0.6-0.42_mm_pct",
  "Size_fraction_0.6-0.5_mm_pct",
  "Size_fraction_0.63-0.4_mm_pct",
  "Size_fraction_0.63-0.5_mm_pct",
  "Size_fraction_0.85-0.6_mm_pct",
  "Size_fraction_1-0.5_mm_pct",
  "Size_fraction_1.0-0.5_mm_pct",
  "Size_fraction_1.0-0.63_mm_pct",
  "Size_fraction_1.6-0.85_mm_pct",
  "Size_fraction_1.6-1.0_mm_pct",
  "Size_fraction_2.0-1.0_mm_pct",
  "Size_fraction_3-2_mm_pct",
  "Size_fraction__0.001_mm_pct",
  "Size_fraction__0.002_mm_pct",
  "Size_fraction__0.005_mm_pct",
  "Size_fraction__0.01_mm_pct",
  "Size_fraction__0.07_mm_pct",
  "Size_fraction__0.5_mm_pct",
  "Size_fraction__0.63_mm_pct",
  "Size_fraction__0.85_mm_pct",
  "Size_fraction__1.6_mm_pct",
  "Size_fraction__1_mm_pct",
  "Size_fraction__2.5-1.6_mm_pct",
  "Size_fraction__2.5_mm_pct",
  "Size_fraction__2_mm_pct",
  "Size_fraction__3_mm_pct",
  "Sm_ppm",
  "Sn_ppm",
  "Sphalerite_pct",
  "Sr_ppm",
  "Staurolite_pct",
  "TOC_pct",
  "TOT_C_pct",
  "TOT_S_pct",
  "Ta_ppm",
  "Talc_pct",
  "Tb_ppm",
  "Te_ppm",
  "Temperatuur_C",
  "Th_ppm",
  "Ti-minerals__weathered__pct",
  "Ti-minerals__weathered_pct",
  "TiO2_pct",
  "TiO2_ppm",
  "Ti_pct",
  "Tihedus_g_cm3",
  "Titanite_pct",
  "Tl_ppm",
  "Tm_ppm",
  "Tourmaline_pct",
  "Transparent_minerals_pct",
  "U_ppm",
  "V_ppm",
  "W_ppm",
  "Wet_density_kg_m3",
  "Xenotime_pct",
  "Y_ppm",
  "Yb_ppm",
  "Zircon_grains",
  "Zircon_pct",
  "Zn_ppm",
  "Zr_ppm",
  "_nest_path_",
  "_root_",
  "_text_",
  "_version_",
  "acronym",
  "age_hierarchy",
  "agent_analysed",
  "agent_analysed_free",
  "analysis_id",
  "analysis_method",
  "analysis_method_en",
  "area",
  "area_id",
  "calcite_pct",
  "carbonates_pct",
  "chlorite_pct",
  "database_id",
  "dataset_id",
  "dataset_ids",
  "dataset_name",
  "delta13C_DIC_permil",
  "delta13C_permil",
  "delta13Corg_permil",
  "delta15N_permil",
  "delta18O_permil",
  "depth",
  "depth_interval",
  "detriit_pct",
  "dolomite_pct",
  "id",
  "illiit-smektiit_pct",
  "illiit_pct",
  "illite_pct",
  "instrument",
  "instrument_id",
  "kaoliniit_pct",
  "kloriit-smektiit_pct",
  "kloriit_pct",
  "lab",
  "lab_en",
  "lab_id",
  "latitude",
  "latlong",
  "lithostratigraphy",
  "lithostratigraphy_en",
  "lithostratigraphy_hierarchy",
  "lithostratigraphy_id",
  "locality",
  "locality_en",
  "locality_id",
  "longitude",
  "looduslik_niiskus_pct",
  "method_details",
  "method_id",
  "montmorilloniit_pct",
  "orgaanika_pct",
  "pH",
  "p_lemissoojus_MJ_kg",
  "parameter_indexes",
  "project_id",
  "project_name",
  "project_name_en",
  "reference",
  "reference_id",
  "rock",
  "rock_en",
  "rock_en_txt",
  "rock_id",
  "rock_txt",
  "samosiit_pct",
  "sample_id",
  "sample_number",
  "sample_type",
  "site",
  "site_id",
  "soil_Al",
  "soil_C",
  "soil_C_N",
  "soil_Ca_mg_kg",
  "soil_Cd",
  "soil_Co_mg_kg",
  "soil_Corg_pct",
  "soil_Cu_mg_kg",
  "soil_De",
  "soil_Dm",
  "soil_E",
  "soil_Erikaal",
  "soil_H56",
  "soil_H82",
  "soil_Hg",
  "soil_Hu_pct",
  "soil_Huumusvaru_t_ha",
  "soil_K",
  "soil_K-DL_mg_kg",
  "soil_Mg_mg_kg",
  "soil_Mn_mg_kg",
  "soil_N",
  "soil_N__ld_pct",
  "soil_P",
  "soil_P-DL_mg_kg",
  "soil_P_pct",
  "soil_Pb",
  "soil_S",
  "soil_So4-",
  "soil_T",
  "soil_V",
  "soil_W",
  "soil_Wmax",
  "soil_Wmh",
  "soil_hu",
  "soil_i",
  "soil_jkl",
  "soil_jkr",
  "soil_jl",
  "soil_jt",
  "soil_karb",
  "soil_kk",
  "soil_kl",
  "soil_korese_maht",
  "soil_kt",
  "soil_l_imis",
  "soil_pHKCL",
  "soil_pH_KCl",
  "soil_pHh2o",
  "soil_pkr",
  "soil_pl",
  "soil_pl1",
  "soil_pl2",
  "soil_pt",
  "stratigraphy",
  "stratigraphy_en",
  "stratigraphy_hierarchy",
  "stratigraphy_id",
  "tuhasus_pct",
  "turba_kasutusala",
  "turba_kasutusala_kood_tuletatud",
  "turba_lagunemisaste__vonPost_",
  "turba_lagunemisaste_pct",
  "weight_mg",
];

export const EXPORT_SOLR_AREA = [
  "id",
  "abstract",
  "area_ha",
  "area_type",
  "area_type_en",
  "area_type_id",
  "creators",
  "database_acronym",
  "database_id",
  "dataset_id",
  "date",
  "date_added",
  "date_changed",
  "deposit_area_ha",
  "description",
  "description_en",
  "doi",
  "doi_url",
  "eelis",
  "egf",
  "kaevandaja",
  "kasutus",
  "language",
  "licence",
  "licence_id",
  "licence_url",
  "loa_number",
  "loa_omanik",
  "maakond",
  "maakond_en",
  "maakond_id",
  "maardla",
  "maavara",
  "me_kood",
  "methods",
  "name",
  "name_en",
  "owner_agent",
  "owner_forename",
  "owner_id",
  "owner_surename",
  "parameter_index_list",
  "parameter_list",
  "parent_area_id",
  "parent_name",
  "parent_name_en",
  "pohimaavara",
  "publication_year",
  "publisher",
  "reg_kaart",
  "remarks",
  "resource",
  "resource_type",
  "staatus",
  "subjects",
  "tingimused",
  "title",
  "title_alternative",
  "title_translated",
];

export const EXPORT_SOLR_DATASET = [
  "abstract",
  "copyright_agent_id",
  "creators",
  "database_acronym",
  "database_id",
  "dataset_html",
  "dataset_id",
  "date",
  "date_added",
  "date_changed",
  "date_txt",
  "description",
  "description_en",
  "doi",
  "doi_url",
  "id",
  "language",
  "licence",
  "licence_id",
  "licence_url",
  "methods",
  "name",
  "name_en",
  "owner_agent",
  "owner_forename",
  "owner_id",
  "owner_surename",
  "parameter_index_list",
  "parameter_list",
  "publication_year",
  "publisher",
  "remarks",
  "resource",
  "resource_type",
  "subjects",
  "timestamp",
  "title",
  "title_alternative",
  "title_translated",
];

export const EXPORT_SOLR_DRILLCORE = [
  "acronym",
  "age_base",
  "age_top",
  "agent",
  "agent_id",
  "box_numbers",
  "boxes",
  "core_repository",
  "core_repository_en",
  "core_repository_id",
  "count_boxes",
  "count_images",
  "country",
  "country_en",
  "country_id",
  "database_id",
  "database_name",
  "database_name_en",
  "date_added",
  "date_changed",
  "locality_depth",
  "depth",
  "direction_lr",
  "drillcore",
  "drillcore_en",
  "elevation",
  "gid",
  "id",
  "igsn",
  "latitude",
  "locality",
  "locality_depth",
  "locality_en",
  "locality_id",
  "location",
  "longitude",
  "number_meters",
  "remarks",
  "storage",
  "storage_address",
  "storage_id",
  "stratigraphy_base",
  "stratigraphy_base_en",
  "stratigraphy_base_free",
  "stratigraphy_base_id",
  "stratigraphy_top",
  "stratigraphy_top_en",
  "stratigraphy_top_id",
  "timestamp",
  "uid",
  "year",
];

export const EXPORT_SOLR_LOCALITY = [
  "age_base",
  "age_top",
  "agent",
  "area_id",
  "area_name",
  "area_name_en",
  "asustusyksus_id",
  "code",
  "coord_det_agent",
  "coord_det_method",
  "coord_det_precision",
  "coord_system",
  "coord_x",
  "coord_y",
  "coordinates_accuracy",
  "coordinates_identified_by",
  "country",
  "country_en",
  "country_id",
  "date_added",
  "date_changed",
  "depth",
  "eelis",
  "elevation",
  "extent",
  "id",
  "image_author",
  "image_date",
  "image_preview_url",
  "image_url",
  "latitude",
  "line_end_hack",
  "locality",
  "locality_en",
  "locality_references",
  "locality_synonyms",
  "locality_type",
  "locality_type_en",
  "locality_type_id",
  "locality_url",
  "longitude",
  "maaamet_pa_id",
  "maakond_id",
  "number",
  "parent_id",
  "related_analyses",
  "related_drillcores",
  "related_files",
  "related_images",
  "related_references",
  "related_samples",
  "related_specimens",
  "related_stratotypes",
  "related_taxon_occurrences",
  "remarks",
  "remarks_location",
  "stratigraphy_base",
  "stratigraphy_base_en",
  "stratigraphy_base_free",
  "stratigraphy_base_id",
  "stratigraphy_top",
  "stratigraphy_top_en",
  "stratigraphy_top_free",
  "stratigraphy_top_id",
  "timestamp",
  "total_related_records",
  "type",
  "vald_id",
  "x",
  "y",
];

export const EXPORT_SOLR_PHOTO = [
  "id",
  "acronym",
  "agent",
  "agent_digitised_id",
  "analysis_id",
  "attachment_format_id",
  "attachment_id",
  "author_free",
  "author_id",
  "boolean1",
  "collection_id",
  "copyright_agent_id",
  "country",
  "country_en",
  "country_id",
  "database_id",
  "dataset_id",
  "date_added",
  "date_changed",
  "date_created",
  "date_created_free",
  "date_created_free_year",
  "date_digitised",
  "date_digitised_free",
  "description",
  "description_en",
  "device_digitised_id",
  "device_id",
  "device_txt",
  "drillcore_box_id",
  "drillcore_id",
  "drillcore_image_id",
  "file",
  "filename",
  "filename_old",
  "format",
  "format_value",
  "image_altitude",
  "image_category",
  "image_category_id",
  "image_description",
  "image_description_en",
  "image_height",
  "image_height_mm",
  "image_id",
  "image_latitude",
  "image_longitude",
  "image_number",
  "image_object",
  "image_people",
  "image_place",
  "image_scalebar",
  "image_type",
  "image_width",
  "image_width_mm",
  "imageset_id",
  "imageset_number",
  "is_preferred",
  "latitude",
  "licence_id",
  "link_id",
  "link_table",
  "locality",
  "locality_en",
  "locality_id",
  "locality_type",
  "longitude",
  "maakond",
  "maakond_en",
  "maakond_id",
  "original_filename",
  "preparation_id",
  "reference",
  "reference_id",
  "remarks",
  "sample_id",
  "size_mb",
  "specimen_id",
  "storage",
  "tags",
  "title",
  "title_en",
  "type",
  "type_id",
  "uuid",
  "uuid_filename",
  "vald",
  "vald_en",
  "vald_id",
];

export const EXPORT_SOLR_PREPARATION = [
  "acronym",
  "age_hierarchy",
  "agent",
  "agent_id",
  "agent_identified",
  "agent_owner",
  "analysis_id",
  "analysis_method",
  "analysis_method_en",
  "class_id",
  "database_id",
  "date_added",
  "date_changed",
  "date_prepared",
  "depth",
  "depth_interval",
  "id",
  "identification_agent_id",
  "identification_date",
  "identification_remarks",
  "image",
  "image_url",
  "latitude",
  "lithostratigraphy",
  "lithostratigraphy_en",
  "lithostratigraphy_hierarchy",
  "lithostratigraphy_id",
  "locality",
  "locality_en",
  "locality_id",
  "location",
  "longitude",
  "mass",
  "owner_id",
  "preparation_number",
  "public",
  "remarks",
  "sample_id",
  "sample_no",
  "sample_number",
  "sample_palaeontology_id",
  "storage_id",
  "stratigraphy",
  "stratigraphy_en",
  "stratigraphy_hierarchy",
  "stratigraphy_id",
  "taxa",
];

export const EXPORT_SOLR_SAMPLE = [
  "id",
  "acronym",
  "age_hierarchy",
  "agent_collected_free",
  "agent_collected_id",
  "analysis",
  "attachment_id",
  "classification_rock_id",
  "collector",
  "collector_full_name",
  "collector_id",
  "coordinate_accuracy",
  "country",
  "country_en",
  "country_id",
  "database_id",
  "date_added",
  "date_changed",
  "date_collected",
  "date_collected_free",
  "db_id",
  "depth",
  "depth_interval",
  "epsg",
  "fossils",
  "has_image",
  "has_map",
  "hierarchy_string_rock",
  "igsn",
  "image_preview_url",
  "image_url",
  "latitude",
  "lithostratigraphy",
  "lithostratigraphy_en",
  "lithostratigraphy_hierarchy",
  "lithostratigraphy_id",
  "locality",
  "locality_en",
  "locality_free",
  "locality_id",
  "location",
  "location_additional",
  "longitude",
  "mass",
  "number",
  "number_additional",
  "number_field",
  "owner_id",
  "palaeontology",
  "parent_sample_id",
  "parent_specimen_id",
  "project_id",
  "project_name",
  "project_name_en",
  "remarks",
  "remarks_en",
  "rock",
  "rock_en",
  "rock_id",
  "rock_txt",
  "rock_txt_en",
  "sample_purpose",
  "sample_type",
  "series_id",
  "site_id",
  "site_name",
  "site_name_en",
  "soil_horizon",
  "soil_site_id",
  "storage_additional_id",
  "storage_id",
  "stratigraphy",
  "stratigraphy_bed",
  "stratigraphy_bed_thickness",
  "stratigraphy_en",
  "stratigraphy_hierarchy",
  "stratigraphy_id",
  "stratigraphy_txt",
];

export const EXPORT_SOLR_SITE = [
  "area_id",
  "area_name",
  "area_name_en",
  "coordinates_accuracy",
  "coordinates_identified_by",
  "date_end",
  "date_free",
  "date_start",
  "depth",
  "epsg",
  "extent",
  "id",
  "latitude",
  "locality",
  "locality_en",
  "longitude",
  "maakond",
  "maakond_en",
  "name",
  "name_en",
  "number",
  "project_id",
  "project_name",
  "project_name_en",
  "remarks",
];

export const EXPORT_SOLR_SPECIMEN = [
  "id",
  "age_hierarchy",
  "collection_id",
  "collection_number",
  "attachment_id",
  "collector_id",
  "collector",
  "country_id",
  "country",
  "country_en",
  "database_id",
  "acronym",
  "date_collected",
  "date_collected_free",
  "depth",
  "depth_interval",
  "formula",
  "formula_html",
  "fossil_group_names",
  "fossilgroup",
  "fossilgroup_id",
  "hierarchy_string",
  "hierarchy_string_rock",
  "image",
  "image_author",
  "image_date",
  "image_preview_url",
  "image_url",
  "keywords",
  "latitude",
  "longitude",
  "lithostratigraphy_id",
  "lithostratigraphy",
  "lithostratigraphy_en",
  "lithostratigraphy_hierarchy",
  "locality_id",
  "locality",
  "locality_en",
  "locality_free",
  "original_status_id",
  "original_status",
  "original_status_en",
  "remarks",
  "rock_id",
  "rock",
  "rock_en",
  "specimen_full_name",
  "specimen_kind",
  "specimen_kind_en",
  "specimen_names",
  "specimen_number",
  "specimen_number_field",
  "specimen_number_old",
  "specimen_part",
  "specimen_references",
  "specimen_status",
  "specimen_status_en",
  "stratigraphy",
  "stratigraphy_en",
  "stratigraphy_hierarchy",
  "stratigraphy_id",
  "taxon",
  "taxon_full",
  "taxon_id",
  "date_added",
  "date_changed",
];

export const EXPORT_SOLR_STRATIGRAPHY = [
  "id",
  "age_base",
  "age_chronostratigraphy",
  "age_precision",
  "age_reference_id",
  "age_stratigraphy",
  "age_stratigraphy_en",
  "age_top",
  "approved_esk",
  "approved_ics",
  "author_free",
  "author_id",
  "biostratigraphy_group_id",
  "color_code_additional",
  "color_code_cgmw",
  "color_code_usgs",
  "definition",
  "definition_en",
  "description",
  "description_en",
  "etymon",
  "etymon_en",
  "has_paleomap",
  "hierarchy_code",
  "hierarchy_string",
  "in_east_baltic",
  "in_estonia",
  "in_scandinavia",
  "index_additional",
  "index_additional_html",
  "index_main",
  "index_main_html",
  "index_old",
  "level",
  "lithology",
  "lithology_en",
  "maaamet_kood",
  "max_thickness",
  "original_locality",
  "original_rank",
  "paleomap_layers",
  "parent_id",
  "parent_stratigraphy",
  "parent_stratigraphy_en",
  "rank",
  "reference",
  "reference_id",
  "region",
  "region_en",
  "remarks",
  "scope",
  "sort_within_parent",
  "status",
  "stratigraphy",
  "stratigraphy_en",
  "stratigraphy_lv",
  "stratigraphy_original",
  "stratigraphy_rank",
  "stratigraphy_rank_en",
  "stratigraphy_references",
  "stratigraphy_ru",
  "stratigraphy_scope",
  "stratigraphy_scope_en",
  "stratigraphy_status",
  "stratigraphy_status_en",
  "stratigraphy_stratotypes",
  "stratigraphy_synonyms",
  "stratigraphy_type",
  "stratigraphy_type_en",
  "synonym",
  "synonym_id",
  "type",
  "year",
  "date_added",
  "date_changed",
];

export const EXPORT_SOLR_TAXON = [
  "id",
  "author_year",
  "common_name",
  "common_names",
  "description",
  "description_reference",
  "descriptions",
  "fad_age_base",
  "fad_stratigraphy",
  "fad_stratigraphy_en",
  "fossil_group",
  "fossil_group_id",
  "genus_id",
  "hierarchy_string",
  "in_baltoscandia",
  "in_estonia",
  "is_authorized",
  "is_fossil",
  "is_fossil_group",
  "is_recombined",
  "is_valid",
  "lad_age_top",
  "lad_stratigraphy",
  "lad_stratigraphy_en",
  "owner",
  "parent_id",
  "parent_taxon",
  "rank",
  "rank_original",
  "reference",
  "reference_author",
  "reference_id",
  "reference_title",
  "reference_year",
  "remarks",
  "species_id",
  "stratigraphy_base",
  "stratigraphy_top",
  "synonym_of",
  "synonym_of_reference_id",
  "taxon",
  "taxon_epithet",
  "taxon_full_name",
  "taxon_id_eol",
  "taxon_id_nrm",
  "taxon_id_pbdb",
  "taxon_id_plutof",
  "taxon_id_tol",
  "taxon_original_name",
  "taxon_rank",
  "taxon_rank_en",
  "taxon_synonym",
  "taxon_synonyms",
  "type_taxon",
  "type_taxon_id",
  "date_added",
  "date_changed",
];
